export default {
  en : {
    MainTitle : 'Drilling',
    Admin : 'Admin',
    Upload : {
      Title : "Upload daily reports",
      Template : "Upload template",
      Templates : {
        AEMTemplate : "AEM Template",
        Coreplan : "Coreplan"
      },
      Reset : "Reset",
      BrowseFiles : "Browse files",
      AddMoreFiles : "Add more files",
      Upload : "Upload",
      Filename : "File name",
      Remove : "Remove",
      FilesSelected : "{count} file(s) selected",
      BadFileExtension : "Only .xlsx and .xlsm files are allowed.",
      ValidationResults : "Validation results",
      ValidationResultsDescription : "{total} file(s) processed — {passed} passed, {failed} failed.",
      StructureStatus : "Structure",
      ContentStatus : "Content",
      Valid : "Valid",
      Invalid : "Invalid",
      StructureValidations : "Structure validations",
      ContentValidations : "Content validations",
      ValidationName : "Validation",
      ClickToShowDetails : "Click to show details",
      Ingest : "Import",
      ImportationSuccessful : "The file(s) have been imported successfully.",
      NoFilesToIngest : "There are no valid files to import.",
      IngestError : "An error occurred while importing the file(s).",
      ValidationResultsCompleteSuccess : "All files passed validation and are ready to import.",
      ValidationResultsPartialSuccess : "Some files failed validation. Only valid files will be imported."
    },
    DailyReports : {
      Title : "Daily Reports",
      Vendor : "Vendor",
      ConfirmDelete : "Do you really want to delete this daily report?",
      ShowDeleted : "Show deleted reports",
      DailyReportDeleted : "The daily report has been successfully deleted",
      NoDailyReportSelected : "No selected daily report",
      ConfirmDeleteMultiple :  "Do you really want to delete the selected daily reports?",
      ConfirmDeleteMultipleImported :  "Among the selected reports, some or all have already been imported. This action will cancel the import. Do you really want to delete these imported daily reports?",
      ConfirmRestore : "Do you really want to restore this report?",
      RestoreCompleted : "Report has been successfully restored",
      ConfirmImport: "Do you really want to import the selected reports?",
      ImportCompleted: "Reports have been successfully imported",
      ConfirmCancelImport: "Do you really want to cancel importation of the selected report?",
      CancelImportCompleted: "Report importation have been successfully cancelled",
      ConfirmCancelImportBatch: "Do you really want to cancel importation of the selected reports?",
      CancelImportCompletedBatch: "Reports importation have been successfully cancelled",
      ConfirmSaveWithInvalidFrom :  "Do you really want to save the report with invalid values?",
      ConfirmImportWithInvalidFrom :  "Do you really want to import the report with invalid values?",
      ShiftRequiredBeforeImport : "Every entry must have a shift before the report can be approved.",
      ShiftRequiredMessage : "Shift is required",
      ImportAndNextReport: "Import and next report",
      ImportSelected: "Import selected reports",
      NoReportSelected: "No report selected",
      Add : "Add a report",
      Edit : "Edit a report",
      View : "View a report",
      CancelImport : "Cancel import",
      Restore : "Cancel delete",
      EditNotes: "Edit notes",
      EditTitle : "{reportDate} - Drill {drillCode}",
      InvalidProject : "Invalid property",
      InvalidContract : "Invalid contract",
      InvalidDrill : "Invalid drill",
      Tab1 : "General Information",
      Tab2 : "Job Entries",
      Tab3 : "Drilling Entries",
      Tab4 : "Stabilisations",
      Tab5 : "Deviation Tests",
      InvalidDataInTab : "Invalid data found in tab",
      Dashboard : "Dashboard",
      Importation: {
        ResultTitle: "Importation results"
      },
      UnapprovedHours: "Unapproved hours",
      ApprovedHours: "Approved hours",
      TotalHours: "Total hours",
      SummaryByEmployee: "Summary by employee"
    },
    JobEntries : {
      Employee : "Employee",
      Title : "Title",
      Shift : "Shift",
      Hours : "Hours",
      TaskPlaceholder: "Name of the task",
      TaskName : "Task",
      EmployeePlaceholder : "Name of the employee",
      EditTask : "Edit task name",
      EditTimeEntry : "Edit time entry",
      AddTimeEntry : "Add time entry",
      AddEmployee : "Add employee",
      AddTask : "Add task",
      IsBillable : "Billable?",
      IsNonBillableShort : "(NB)",
      ShowAllTasks : "Show all tasks",
      StatsTitle :"Job Entries",
      OtherTask: "Other task",
      Note: "Note",
      DuplicateEntry: "Duplicate entry",
      InitialValue: "Initial value:"
    },
    DrillEntries : {
      Dip : "Dip",
      Azimut : "Azimut",
      CoreSize : "Core Size",
      From : "From",
      To : "To",
      MetersDrilled : "Meters Drilled",
      IsEndOfHole : "End of Hole",
      IsDevico : "Directional",
      IsOriented : "Oriented",
      IsAutomated: "Automated",
      IsCemented : "Cemented",
      ToLowerThanFromMessage : "Invalid Meters Drilled",
      FromDiffThanPreviousEntry : "From value is different than previous entry ({latestTo})",
      HoleEnded : "This hole was declared ended on a previous entry",
      AddDrillingEntry : "Add drilling entry",
      EditDrillingEntry : "Edit drilling entry",
      AddNewHole : "Add new hole",
      AddHoleInProject : "Add this hole in the property",
      StatsTitle :"Drilling Entries",
      NotesTitle : "Notes",
      Note: "Note",
      LastValue: "Last value:",
      Author: "Author"
    },
    Stabilisations : {
      CoreBarrel: "Core Barrel",
      Shell: "Shell (length)",
      Length: "Length",
      Quantity: "Quantity",
      MustBeGreaterThanPreviousTo: "Value must be greater than previous To of latest stabilisation entry ({latestTo}).",
      FromMustBeLessThanTo: "From must be less than To",
      AddEntry: "Add stabilisation entry"
    },
    Drills : {
      Title : "Drills",
      Name : "Drill",
      Code : "Code",
      IsActive : "Is active?",
      IsAutomated : "Is automated?",
      DrillingCapacity : "Drilling capacity",
      MovedBy : "Moved by",
      Dimensions : "Dimensions",
      Length : "Length",
      Width : "Width",
      Height : "Height",
      AddNew: "Add new drill",
      Edit : "Update drill",
      ConfirmDelete : "Do you really want to delete this drill?",
      DrillDeleted : "The drill has been successfully deleted"
    },
    Holes : {
      Name : "Hole",
      Title : "Holes",
      Code : "Code",
      AddNew: "Add new hole",
      Edit : "Update hole",
      Easting : "Easting",
      Northing : "Northing",
      CollarAzimuth : "Collar Azimuth",
      CollarDip : "Collar Dip",
      LiftRate : "Lift Rate",
      DriftRate : "Drift Rate",
      Distance : "Distance",
      Extension : "Extension",
      Target : "Target",
      TargetZone : "Zone",
      TargetDepth : "Target Depth",
      TargetPriority : "Priority",
      StartMeters : "Starting Depth (m)",
      ConfirmDelete : "Do you really want to delete this hole?",
      HoleDeleted : "The hole has been successfully deleted",
      LatestTo: "Latest To",
      LatestToDate: "Latest To Date",
      IsEndOfHole: "End of Hole",
      EndOfHole: "Close Hole",
      ReverseEndOfHole: "Open Hole",
      ShowAllHoles: "Show all holes",
      NoSelection: "No hole selected",
      SelectHole: "Select a hole",
      EndOfHoleSet: "End of hole has been set successfully",
      EndOfHoleNotSet: "End of hole has not been set"
    },
    HoleStatus : {
      'Name' : "Hole status",
      '0' : "Planned",
      '1' : "In Progress",
      '2' : "Done"
    },
    DrillHoleTypes : {
      'Name' : "Hole type",
      '1' : "Conversion",
      '2' : "Extension",
      '3' : "Exploration",
      '4' : "Geotechnical",
      '5' : "Delineation",
      '6' : "Definition",
      '7' : "Service Hole",
      '99' : "Unknown"
    },
    ExpenseTypes: {
      "Name": "Expense type",
      "1": "Capitalize growth",
      "2": "Capitalize sustaining",
      "3": "Expense",
      "4": "Operating"
    },
    CoordinateSystemTypes : {
      'Name' : "Coordinate System type",
      '1' : "UTMNAD83 Zone 17N",
      '2' : "Upper Canada Geo Grid",
      '3' : "Upper Beaver Geo Grid",
      '4' : "UTMNAD83 Zone 14",
      '5' : "UTMNAD83 Zone 15",
      '99' : "Unknown"
    },
    DrillingTypes : {
      'Name' : "Drilling Types",
      '1' : "Diamond Drill",
      '2' : "Directional",
      '3' : "Down the Hole Hammer",
      '4' : "Rotary Air Blast Drilling",
      '5' : "Reverse Circulation",
      '6' : "Sludge drilling",
      '7' : "Soil",
      '8' : "Sonic Drilling",
      '9' : "Blast Hole Type",
      '99' : "Unknown"
    },
    RigTransportTypes : {
      'Name' : "Rig Transport Type",
      '1' : "Skid-Drill",
      '2' : "Fly-Drill"
    },
    MovedBy : {
      'Name' : 'Moved by',
      '0' : "Trailer",
      '1' : "Self-propelled"
    },
    Contracts : {
      Title : "Contracts",
      Name : "Contract",
      Code : "Code",
      Location : "Location",
      Property : "Property",
      State : "State",
      Vendor : "Vendor",
      Company : "Company",
      AddNew: "Add new contract",
      Edit : "Update contract",
      ConfirmDelete : "Do you really want to delete this contract?",
      ContractDeleted : "The contract has been successfully deleted",
      CodeNotUnique : "The code must be unique."
    },
    Projects : {
      Title : "Properties",
      SingleTitle : "Property",
      Name : "Name",
      Code : "Code",
      CodeUnique : "This code already exists and cannot be added.",
      District : "District",
      Country : "Country",
      HolePrefix : "Hole Prefix",
      BusinessUnitCode : "Business Unit Code",
      Edit : "Update property",
      ConfirmDelete : "Do you really want to delete this property?",
      ProjectDeleted : "The property has been successfully deleted",
      Tab1 : "General Information",
      Tab2 : "Zones",
      Tab3 : "Holes"
    },
    Zones : {
      Title : "Zones",
      SingleTitle : "Zone",
      Name : "Name",
      Edit : "Update zone",
      ZonePlaceholder : "Zone name",
      ConfirmDelete : "Do you really want to delete this zone?"
    },
    Companies : {
      Title : "Companies",
      Name : "Company",
      ShortName : "Short name",
      Address : "Address",
      City : "City",
      Province : "Province",
      Contact : "Contact",
      Phone : "Phone number",
      Email : "Email",
      AddNew: "Add new company",
      Edit : "Update company",
      ConfirmDelete : "Do you really want to delete this company?",
      CompanyDeleted : "The company has been successfully deleted"
    },
    Employees : {
      Title : "Employees",
      Name : "Employee",
      FirstName : "First Name",
      LastName : "Last Name",
      ReferenceName : "Reference Name",
      IsActive: "Active",
      EmployeeNumber: "Employee Number",
      Company : "Company",
      AddNew: "Add new employee",
      Edit : "Update employee",
      ConfirmDelete : "Do you really want to delete this employee?",
      DeletedConfirmation : "The selected employee was successfully deleted"
    },
    Reports : {
      Title : "Reports",
      Dashboard : "Dashboard (Legacy)",
      Optimized : "Dashboard",
      Analytics: "Drilling Analytics"
    },
    Unmapped : {
      ConfirmDelete: "Are you sure you want to delete this daily report?",
      ConfirmDeleteMultiple :  "Do you really want to delete the selected daily reports?",
      ConfirmRestore: "Are you sure you want to restore this daily report?",
      DailyReportsDeleted : "The daily report has been successfully deleted",
      ContractNumber: "Contract #",
      Vendor: "Vendor",
      DrillCode: "Drill code",
      DeleteHeader: "Remove",
      RemoveFromBatch: "Remove from batch",
      MapToContract: "Assign to contract",
      Contract: "Contract",
      Title: "Daily reports without existing contract",
      BatchMapping: "Edit selected daily reports",
      BatchDelete: "Delete selected daily reports",
      Mapping: "Assign to contract",
      ReportDate: "Date",
      NoRowsSelected: "Please select at least one row"
    },
    EmployeeTitles : {
      Title : "Titles",
      NameFr : "Name (french)",
      NameEn : "Name (english)",
      AlternateNames : "Alternate names (separated by semicolon)",
      AddNew: "Add new title",
      Edit : "Update title",
      ConfirmDelete : "Do you really want to delete this title?",
      Deleted : "The title has been successfully deleted"
    },
    Tasks : {
      Title: "Tasks",
      TitleWithSelectedCategory: "Tasks for ",
      Name: "Task",
      NameEn: "Name (en)",
      NameFr: "Name (fr)",
      DescriptionEn: "Description (en)",
      DescriptionFr: "Description (fr)",
      AlternateNames: "Alternate names (separated by semicolon)",
      Category: "Category",
      AddNew: "Add new task",
      Edit : "Update task",
      ConfirmDelete : "Do you really want to delete this task?",
      DeletedConfirmation : "The selected task was successfully deleted"
    },
    Categories : {
      Title: "Categories",
      Name: "Category",
      NameEn: "Name (en)",
      NameFr: "Name (fr)",
      AddNew: "Add new category",
      Edit : "Update category",
      ConfirmDelete : "Do you really want to delete this category?",
      DeletedConfirmation : "The selected category was successfully deleted"
    },
    Shift: {
      '0': "Day",
      '1': "Night"
    },
    Instruments : {
      Title: "Instruments",
      Name: "Instrument",
      DescriptionEn: "Description (en)",
      DescriptionFr: "Description (fr)",
      AlternateNames: "Alternate names (separated by semicolon)",
      AddNew: "Add new instrument",
      Edit : "Update instrument",
      ConfirmDelete : "Do you really want to delete this instrument?",
      DeletedConfirmation : "The selected instrument was successfully deleted",
      IsActive: "Active",
      ShowInactive: "Show inactive"
    },
    CoreBarrels : {
      Title: "Core Barrels",
      NameEn: "Name (en)",
      NameFr: "Name (fr)",
      AlternateNames: "Alternate names (separated by semicolon)",
      AddNew: "Add new core barrel",
      Edit : "Update core barrel",
      ConfirmDelete : "Do you really want to delete this core barrel?",
      DeletedConfirmation : "The selected core barrel was successfully deleted"
    },
    DeviationTests : {
      MaxDepth: "Max",
      Depth: "Depth",
      Azimuth: "Azimuth",
      Inclination: "Inclination",
      InstrumentName: "Imported value",
      Magnetism: "Magnetism",
      AddNew: "Add new test",
      Edit : "Update deviation test",
      ConfirmDelete : "Do you really want to delete this deviation test?",
      DeletedConfirmation : "The selected deviation test was successfully deleted",
      DepthGreaterThanMaxDepth : "Depth must be less than or equal to the maximum depth ({maxDepth})"
    },
    Cementation: {
      Title: "Cementation",
      Name: "Cementation",
      AddNew: "Add new cementation",
      Edit : "Update cementation",
      EditSelected: "Edit selected cementations",
      ConfirmDelete : "Do you really want to delete this cementation?",
      DeletedConfirmation : "The selected cementation was successfully deleted",
      Project: "Project",
      Zone: "Zone",
      HoleName: "Hole",
      Drill: "Latest Drill",
      Contract: "Latest Contract",
      DrillingStarted: "Drilling started on",
      DrillingEnded: "Drilling ended on",
      ChangeStatus: "Change cementation status",
      CementedOn: "Cemented on",
      CementedFrom: "From",
      CementedTo: "To",
      LitersPumped: "Liters pumped",
      Filter: "Cementation status",
      NoRowsSelected: "Please select at least one row",
      SaveError: "Error while saving the cementation. Please make sure all required fields are filled and try again."
    },
    CementationType: {
      0: "Active",
      1: "Plugged",
      2: "Cemented"
    }
  }
}
